import { useCallback, useEffect, useState } from 'react'

/**
 * Hook to store data in the local storage
 * @param {string} key - The default value of the list
 * @param {*} defaultValue - The default value of the list
 * @return {[*, function, function]} The value, the setter and a function to remove the property from the storage
 */
const useLocalStorage = (key, defaultValue = undefined) => {
    const [value, setValue] = useState(() => {
        const storeValue = window.localStorage.getItem(key)
        if (storeValue !== null) {
            try {
                return JSON.parse(decodeURIComponent(window.atob(storeValue)))
            } catch (_) {
                return decodeURIComponent(window.atob(storeValue))
            }
        }
        if (typeof defaultValue === 'function') {
            return defaultValue()
        }
        return defaultValue
    })

    useEffect(() => {
        if (value === undefined) {
            return window.localStorage.removeItem(key)
        }
        window.localStorage.setItem(key, window.btoa(encodeURIComponent(JSON.stringify(value))))
    }, [key, value])

    const remove = useCallback(() => {
        setValue(undefined)
    }, [])

    return [value, setValue, remove]
}

export default useLocalStorage